// Um mapa só de `errorCode` -> frase PT-BR para TODO o módulo de desembolso: o editor
// de regra, o editor de grupo e a seção "Desembolso deste mês" falam com os mesmos
// handlers (`rulesStore`/`groupPlanner`/`handlerSupport` no back-end) e recebem os
// mesmos códigos. Três mapas divergentes era o jeito garantido de uma tela mostrar
// frase e a outra mostrar o código cru.
//
// Cada chamador põe o seu PREFIXO ("Não foi possível salvar a regra." etc.) na frente
// da frase; o que mora aqui é só a explicação, sem sujeito.
//
// Códigos deliberadamente FORA daqui, porque quem os trata escreve frase própria:
// `group_overlap` (precisa do nome do grupo em conflito) e `invalid_adjustment` (o
// back-end manda a `message` — só ele sabe qual regra de negócio barrou o ajuste).

export const DISBURSEMENT_ERROR_DETAIL = Object.freeze({
  // --- transporte / escopo do cliente
  network_error: "Verifique a conexão e tente novamente.",
  project_scope_required: "Abra a obra novamente e repita.",

  // --- forma de desembolso (validador compartilhado FE/BE)
  profile_sum: "Os percentuais precisam somar exatamente 100%.",
  profile_empty: "A forma de desembolso precisa de pelo menos uma linha.",
  profile_line_invalid:
    "Cada linha precisa de defasagem inteira e percentual positivo.",
  profile_offset_range: "Alguma defasagem está fora do intervalo aceito.",
  profile_offset_duplicate: "Cada defasagem só pode aparecer uma vez.",
  profile_too_long: "A forma de desembolso tem linhas demais.",

  // --- alvo e regra (`rulePlanner`/`rulesStore`)
  invalid_target: "Esse alvo não é aceito para uma regra.",
  rule_not_found: "Essa regra não existe mais nesta obra.",
  invalid_source: "A origem da regra não é aceita.",
  invalid_patch: "Nada para alterar.",
  scope_conflict:
    "Este cadastro pertence a outra obra e não pode ser alterado aqui.",
  financial_item_out_of_scope: "Esse item financeiro não pertence a esta obra.",
  invalid_override: "A lista de regras a desativar é inválida.",
  override_rule_invalid:
    "Uma das regras dos insumos mudou desde a prévia. Confira a prévia atualizada e salve de novo.",
  override_requires_preview:
    "Aguarde a prévia de impacto antes de desativar as regras dos insumos.",

  // --- grupos Ampli (`groupPlanner`)
  group_name_taken: "Já existe um grupo com este nome nesta obra.",
  group_not_found: "Esse grupo não existe mais nesta obra.",
  group_id_conflict:
    "Não foi possível gerar um identificador para o grupo. Tente outro nome.",
  invalid_criterion:
    "Critério inválido. Revise a descrição ou selecione ao menos um insumo.",
  invalid_group: "Dados do grupo inválidos. Revise o nome e o critério.",

  // --- ajustes de mês
  adjustment_not_found: "Esse ajuste não existe mais nesta obra.",

  // --- lote (`rulesStore.applyBulk`, consumido pelo confirm da organização por IA)
  bulk_empty: "Nenhuma regra ou grupo foi selecionado para aplicar.",
  bulk_too_large: "O lote tem itens demais. Aplique em partes menores.",
  bulk_duplicate_entry: "O lote repete o mesmo alvo duas vezes.",
  // Falha de asserção interna (bug), não erro de negócio — o back-end já troca a
  // mensagem original por uma genérica antes de responder; aqui só evitamos o
  // fallback cru "A IA está temporariamente indisponível." num contexto que não é de IA.
  invariant_broken:
    "Ocorreu um erro inesperado. Tente novamente ou avise o suporte.",

  // --- rascunhos de IA (`disbursementAiApi`: organizar em lote e assistente de regra)
  ai_draft_version_conflict:
    "O rascunho mudou desde a revisão. Recarregue e confirme de novo.",
  ai_draft_not_found: "O rascunho expirou. Gere a proposta de novo.",

  // --- porteiros do módulo (`handlerSupport`)
  presentation_read_only: "Obra de apresentação: edição desabilitada.",
  ampli_disbursement_disabled: "Esta obra não usa o desembolso Ampli.",
  regeneration_cap_exceeded:
    "A curva foi regerada muitas vezes seguidas. Aguarde um instante e tente de novo.",
  // Conflito de concorrência: o back-end recusou a escrita porque a revisão do módulo
  // mudou no meio do caminho. Nada foi perdido — é literalmente "tente de novo".
  state_revision_bump_conflict:
    "Outra alteração foi salva ao mesmo tempo. Tente novamente.",
  // `assertRegenerator` lança ANTES de tocar o banco (`rulesStore.js`): quando este
  // código chega, NADA foi gravado. Dizer "salvo, mas a curva não regerou" seria
  // mentira — e o cliente sairia da tela achando que a regra existe.
  regenerator_unavailable:
    "Não foi possível regenerar a curva agora; a alteração não foi salva. Tente mais tarde.",
});

/** `null` quando o código é desconhecido — o chamador cai na frase genérica dele. */
export const disbursementErrorDetail = (errorCode) =>
  DISBURSEMENT_ERROR_DETAIL[errorCode] ?? null;
